import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import { Table, Input, Button } from "reactstrap";
import axios from "axios";
import SurtirPedidoModal from "../../../SurtirPedidoModal";
import { hoyLocal } from "../../../fechaLocal";

// Una pantalla solo para surtir: los pedidos abiertos que todavia tienen piezas
// por surtir, y en cada uno el boton que abre la misma ventana de surtido del
// listado de pedidos (pendiente por color y talla con la existencia del almacen).
// Los prepedidos no se surten, asi que no salen.
const headers = () => ({ Authorization: `Bearer: ${localStorage.getItem("app_token")}` });
const num = (n) => new Intl.NumberFormat("en-US").format(Number(n) || 0);

function SurtirPedidos() {
  const { user } = useContext(AuthContext);
  const [pedidos, setPedidos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [buscar, setBuscar] = useState("");
  const [pedidoSurtir, setPedidoSurtir] = useState(null);

  function carga() {
    setCargando(true);
    axios.get(`${process.env.REACT_APP_URL_PEDIDOS}FechasStatus/2000-01-01/${hoyLocal()}/Abierto`, { headers: headers() })
      .then((r) => {
        let lista = r.data || [];
        // el vendedor solo ve sus pedidos, igual que en el listado
        if (user.vendedor === "Si") lista = lista.filter((p) => p.colaboradores?.[0]?.email === user.email);
        setPedidos(lista
          .filter((a) => (a.tipo || "Pedido") === "Pedido" && a.is_active === "Si" && a.surtido !== "Si")
          .map((a) => ({
            _id: a._id,
            numero: a.idPedido,
            fecha: a.fecha,
            clientes: a.clientes?.[0]?.nombre_comercial || "",
            idClientes: a.clientes?.[0]?._id,
            colaboradores: `${a.colaboradores?.[0]?.nombre || ""} ${a.colaboradores?.[0]?.apellido || ""}`.trim(),
            idColaboradores: a.colaboradores?.[0]?._id,
            idEmpresas: a.empresas?.[0]?._id || a.empresas?.[0],
            ordenCompraCliente: a.ordenCompraCliente && a.ordenCompraCliente !== "NA" ? a.ordenCompraCliente : "",
            fechaCancelacion: a.fechaCancelacion,
            total: Number(a.total_cantidad) || 0,
            surtidas: Number(a.piezasEntregadas) || 0,
            pendientes: (Number(a.total_cantidad) || 0) - (Number(a.piezasEntregadas) || 0),
          }))
          .filter((p) => p.pendientes > 0)
          .sort((a, b) => (a.fecha > b.fecha ? 1 : a.fecha < b.fecha ? -1 : parseFloat(a.numero) - parseFloat(b.numero))));
        setCargando(false);
      })
      .catch(() => setCargando(false));
  }
  useEffect(() => { carga(); }, []); // eslint-disable-line

  const q = buscar.trim().toUpperCase();
  const visibles = pedidos.filter((p) => !q || [p.numero, p.clientes, p.ordenCompraCliente, p.colaboradores]
    .some((x) => String(x || "").toUpperCase().includes(q)));
  const totalPendiente = visibles.reduce((s, p) => s + p.pendientes, 0);

  return (
    <>
      <Header />
      <div className="card container col-12">
        <h3 align="center" style={{ marginTop: 12 }}>Surtir pedidos</h3>
        <p style={{ textAlign: "center", color: "#64748b", marginBottom: 14 }}>
          Pedidos abiertos con piezas por surtir. El botón <b>Surtir</b> trae lo pendiente por color y talla con la existencia del almacén.
        </p>
        <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 10, flexWrap: "wrap" }}>
          <Input bsSize="sm" style={{ maxWidth: 320 }} placeholder="Buscar pedido, cliente, OC o vendedor"
            value={buscar} onChange={(e) => setBuscar(e.target.value)} />
          <span style={{ marginLeft: "auto", color: "#64748b", fontSize: 13 }}>
            {visibles.length} pedido(s) · <b>{num(totalPendiente)}</b> piezas por surtir
          </span>
        </div>
        <div style={{ overflowX: "auto" }}>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <thead>
              <tr>
                <th className="tituloTabla">Pedido</th>
                <th className="tituloTabla">Fecha</th>
                <th className="tituloTabla">Cliente</th>
                <th className="tituloTabla">OC Cliente</th>
                <th className="tituloTabla">Vendedor</th>
                <th className="tituloTabla">Cancelación</th>
                <th className="tituloTabla" style={{ textAlign: "right" }}>Piezas</th>
                <th className="tituloTabla" style={{ textAlign: "right" }}>Surtidas</th>
                <th className="tituloTabla" style={{ textAlign: "right" }}>Por surtir</th>
                <th className="tituloTabla"></th>
              </tr>
            </thead>
            <tbody>
              {cargando ? (
                <tr><td colSpan={10} style={{ textAlign: "center", color: "#94a3b8" }}>Cargando...</td></tr>
              ) : !visibles.length ? (
                <tr><td colSpan={10} style={{ textAlign: "center", color: "#94a3b8" }}>No hay pedidos por surtir.</td></tr>
              ) : visibles.map((p) => (
                <tr key={p._id}>
                  <td><b>{p.numero}</b></td>
                  <td>{p.fecha}</td>
                  <td>{p.clientes}</td>
                  <td>{p.ordenCompraCliente}</td>
                  <td>{p.colaboradores}</td>
                  <td>{p.fechaCancelacion}</td>
                  <td style={{ textAlign: "right" }}>{num(p.total)}</td>
                  <td style={{ textAlign: "right" }}>{num(p.surtidas)}</td>
                  <td style={{ textAlign: "right", fontWeight: 700, color: "#b45309" }}>{num(p.pendientes)}</td>
                  <td>
                    <Button size="sm" color="success" disabled={!user.surtidos_create}
                      title={user.surtidos_create ? "Surtir este pedido" : "No tienes permiso de surtir"}
                      onClick={() => setPedidoSurtir(p)}>
                      <i className="fas fa-truck-moving" /> Surtir
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>

      <SurtirPedidoModal
        abierto={!!pedidoSurtir}
        cerrar={() => setPedidoSurtir(null)}
        pedido={pedidoSurtir}
        user={user.id}
        onSurtido={() => { setPedidoSurtir(null); carga(); }}
      />
    </>
  );
}

export default SurtirPedidos;
